import { FC } from "react";
import { styled } from "@mui/material/styles";
import MuiFormControlLabel, {
  FormControlLabelProps,
} from "@mui/material/FormControlLabel";

const StyledFormControlLabel = styled(MuiFormControlLabel)(({ theme }) => ({
  "&.MuiFormControlLabel-root": {
    fontFamily: theme.fonts.regular,
    fontSize: 14,
    fontWeight: 400,
  },
}));

const FormControlLabel: FC<FormControlLabelProps> = (props) => {
  return <StyledFormControlLabel {...props} />;
};

export default FormControlLabel;
